import { firestore, firebase, storage } from '../../config/firebaseConfig';
import * as firebaser from 'firebase'; // get me the firebase restaurantbase
// const restaurantbaseRef = firebase.restaurantbase().ref();
// //console.log(restaurantbaseRef)
//

var user = firebase.auth().currentUser;

// Add new restaurant
export const addCategory = category => async (dispatch, getState) => {
  // //console.log("****************************************************************************")
  //console.log(user);
  //restaurant.userId = user.uid
  firebase.auth().onAuthStateChanged(async user => {
    if (user) {
      category.status = 'open';
      //console.log(user);
      category.createdAt = Date.now();

      //console.log(category);

      const state = getState();
      //console.log(state);

      const restaurant = state.restaurantState.attributes;

      firestore
        .collection('restaurant')
        .doc(restaurant.id)
        .collection('categories')
        .add(category)
        .then(res => {
          //console.log(res);
          // register was succesful by sending true
          dispatch({
            type: 'addCategory',
            payload: { ...category, id: res.id }
          });
          dispatch({ type: 'clearError' });
        })
        .catch(err => {
          //console.log(err);
          dispatch({
            type: 'setError',
            payload: {
              msg: err.message,
              status: 'error',
              id: err.code
            }
          });
        });
    } // user is undefined if no user signed in
    else
      dispatch({
        type: 'setError',
        payload: {
          msg: '',
          status: 'error',
          id: 77889
        }
      });
  });
};

// get all available restaurants
export const listCategories = type => async (dispatch, getState) => {
  // //console.log("****************************************************************************")
  // const state = getState();
  // //console.log(state.authState);
  var user = firebase.auth().currentUser;
  //console.log(user);
  if (user) {
    //console.log(user);

    const state = getState();
    //console.log(state);

    try {
      let catRef = firestore
        .collection('restaurant')
        .doc(state.restaurantState.attributes.id)
        .collection('categories')
        .orderBy('sno');

      // const arestaurants = await restaurantRef.get();
      const catarray = await catRef.get();
      const categories = [];
      let latsno = -1;
      catarray.forEach((categoryList, index) => {
        let catdata = categoryList.data();

        catdata.sno = index;
        categories.push({ ...categoryList.data(), id: categoryList.id });
      });

      //console.log(categories);

      dispatch({ type: 'listCategories', payload: categories });
      dispatch({ type: 'clearError' });
      // //console.log("end")
    } catch (err) {
      //console.log(err);
      dispatch({
        type: 'setError',
        payload: {
          msg: err.message,
          status: 'error',
          id: err.code
        }
      });
    }
  } else {
    //console.log('error');
  }
  // });
};

// Update new restaurant
export const updateCategory = category => async (dispatch, getState) => {
  //console.log('inside update category');
  //restaurant.userId = user.uid

  var user = firebase.auth().currentUser;
  if (user) {
    //console.log(user);

    const state = getState();
    //console.log(state);

    const ccat = state.restaurantState.categories.find(
      cat => cat.id === category.id
    );
    //console.log(ccat);

    const updatedone = { ...ccat, ...category };
    //console.log(updatedone);

    delete updatedone.items;
    delete updatedone.genericOptions;
    firestore
      .collection('restaurant')
      .doc(state.restaurantState.attributes.id)
      .collection('categories')
      .doc(category.id)
      .set(updatedone)
      .then(res => {
        //console.log(res);
        dispatch({ type: 'UpdateCategory', payload: updatedone });
        dispatch({ type: 'clearError' });
      })
      .catch(err => {
        //console.log(err);
        dispatch({
          type: 'setError',
          payload: {
            msg: err.message,
            status: 'error',
            id: err.code
          }
        });
      });
  } // user is undefined if no user signed in
  else
    dispatch({
      type: 'setError',
      payload: {
        msg: '',
        status: 'error',
        id: 77889
      }
    });
};

//db.collection('cities').doc('DC').delete();

// delete restaurant
export const deleteCategory = catid => async (dispatch, getState) => {
  //console.log('deleting------------------restaurant');
  //restaurant.userId = user.uid
  var user = firebase.auth().currentUser;
  if (user) {
    const state = getState();
    //console.log(state);

    let catRef = firestore
      .collection('restaurant')
      .doc(state.restaurantState.attributes.id)
      .collection('categories')
      .doc(catid)
      .delete()

      .then(res => {
        // //console.log(
        //   '@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@'
        // );
        //console.log(res);

        let categories = state.restaurantState.categories.filter(
          cat => cat.id !== catid
        );

        categories = categories.map((cat, index) => {
          cat.sno = index;
          return cat;
        });

        //console.log(categories);

        let catRef = firestore
          .collection('restaurant')
          .doc(state.restaurantState.attributes.id)
          .collection('categories');

        let catfinal = categories.map(cat => {
          catRef.doc(cat.id).set(cat);
        });

        dispatch({ type: 'deleteCategory', payload: categories });
        dispatch({ type: 'clearError' });
      })
      .catch(err => {
        //console.log(err);
        dispatch({
          type: 'setError',
          payload: {
            msg: err.message,
            status: 'error',
            id: err.code
          }
        });
      });
  } // user is undefined if no user signed in
  else
    dispatch({
      type: 'setError',
      payload: {
        msg: '',
        status: 'error',
        id: 77889
      }
    });
};

// delete restaurant
export const sortCategories = categories => async (dispatch, getState) => {
  //console.log('sorting------------------categories');
  //restaurant.userId = user.uid
  var user = firebase.auth().currentUser;
  if (user) {
    const state = getState();
    //console.log(state);

    try {
      // let categories = state.restaurantState.categories;
      //console.log(categories);
      categories = categories.map((cat, index) => {
        cat.sno = index;
        delete cat.items;
        delete cat.genericOptions;
        return cat;
      });

      let catRef = firestore
        .collection('restaurant')
        .doc(state.restaurantState.attributes.id)
        .collection('categories');

      let catfinal = categories.map(cat => {
        catRef.doc(cat.id).set(cat);
      });
      // //console.log(categories)
      dispatch({ type: 'sortCategories', payload: categories });
      dispatch({ type: 'clearError' });
    } catch (err) {
      //console.log(err);
      dispatch({
        type: 'setError',
        payload: {
          msg: err.message,
          status: 'error',
          id: err.code
        }
      });
    }
  } // user is undefined if no user signed in
  else
    dispatch({
      type: 'setError',
      payload: {
        msg: 'user not found',
        status: 'error',
        id: 77889
      }
    });
};

export const addItem = item => async (dispatch, getState) => {
  //console.log('inside add items');
  //restaurant.userId = user.uid
  var user = firebase.auth().currentUser;
  if (user) {
    //console.log(user);

    const state = getState();
    //console.log(state);
    item.soldout = false;
    item.hide = false;
    // item.createdAt = Date.now();

    const restaurant = state.restaurantState.attributes;
    //console.log(restaurant.id);
    //console.log(item);
    if (typeof item.image === 'object') item.image = item.image.name;

    const options = { ...item.options };
    const variations = { ...item.variations };
    delete item.options;
    delete item.variations;
    try {
      const ritem = await firestore
        .collection('restaurant')
        .doc(restaurant.id)
        .collection('categories')
        .doc(item.catid)
        .collection('items')
        .add(item);

      //console.log(ritem);
      //console.log(ritem.id);

      options.map(async opt => {
        delete opt.tableData;
        const ropt = await firestore
          .collection('restaurant')
          .doc(restaurant.id)
          .collection('categories')
          .doc(item.catid)
          .collection('items')
          .doc(ritem.id)
          .collection('options')
          .add({ option: opt.option });
        //console.log(`options id ${ropt.id}`);
        opt.detail.map(async sub => {
          delete sub.tableData;
          const rsub = await firestore
            .collection('restaurant')
            .doc(restaurant.id)
            .collection('categories')
            .doc(item.catid)
            .collection('items')
            .doc(ritem.id)
            .collection('options')
            .doc(ropt.id)
            .collection('detail')
            .add(sub);

          //console.log(rsub);
        });

        //console.log(ropt);
      });

      variations.map(async opt => {
        delete opt.tableData;
        const ropt = await firestore
          .collection('restaurant')
          .doc(restaurant.id)
          .collection('categories')
          .doc(item.catid)
          .collection('items')
          .doc(ritem.id)
          .collection('variations')
          .add(opt);

        //console.log(ropt);
      });
      // register was succesful by sending true
      dispatch({
        type: 'addItem',
        payload: { ...item, id: ritem.id }
      });
      dispatch({ type: 'clearError' });
    } catch (err) {
      //console.log(err);
      dispatch({
        type: 'setError',
        payload: {
          msg: err.message,
          status: 'error',
          id: err.code
        }
      });
    }
  } // user is undefined if no user signed in
  else
    dispatch({
      type: 'setError',
      payload: {
        msg: 'undefined user',
        status: 'error',
        id: 77889
      }
    });
};

// get all available restaurants
export const listItems = catid => async (dispatch, getState) => {
  // //console.log("****************************************************************************")
  // const state = getState();
  // //console.log(state.authState);
  var user = firebase.auth().currentUser;
  //console.log(user);
  if (user) {
    //console.log(user);

    const state = getState();
    //console.log(state);

    let itemsRef = firestore
      .collection('restaurant')
      .doc(state.restaurantState.attributes.id)
      .collection('categories')
      .doc(catid)
      .collection('items')
      .orderBy('createAt', 'desc');

    try {
      // const arestaurants = await restaurantRef.get();
      const itemarray = await itemsRef.get();
      const items = [];

      itemarray.forEach(itemList => {
        items.push({ ...itemList.data(), id: itemList.id });
      });

      //console.log(items);

      dispatch({ type: 'listItems', payload: { items, catid } });
      dispatch({ type: 'clearError' });
      // //console.log("end")
    } catch (err) {
      //console.log(err);
      dispatch({
        type: 'setError',
        payload: {
          msg: err.message,
          status: 'error',
          id: err.code
        }
      });
    }
  } else {
    //console.log('error');
  }
  // });
};
//cid, tid, rid
// get all available restaurants
export const getItemByID = (catid, itemid, rid) => async (
  dispatch,
  getState
) => {
  // //console.log("****************************************************************************")
  // //console.log(catid,itemid)
  // const state = getState();
  // //console.log(state.authState);
  var user = firebase.auth().currentUser;
  //console.log(user);
  // if (user) {
  
  //console.log(catid);
  //console.log(itemid);

  const state = getState();
  //console.log(state);
  const restid = state.restaurantState.attributes.id
    ? state.restaurantState.attributes.id
    : rid;

  let itemsOptions = firestore
    .collection('restaurant')
    .doc(restid)
    .collection('categories')
    .doc(catid)
    .collection('items')
    .doc(itemid)
    .collection('options');

  try {
    // const arestaurants = await restaurantRef.get();
    const itemOptions = await itemsOptions.get();

    //console.log(itemOptions);
    const options = [];

    itemOptions.forEach(async doc => {
      let detail = [];
      let detailquery = await itemsOptions
        .doc(doc.id)
        .collection('detail')
        .get();
      detailquery.forEach(detaildoc => {
        detail.push({ ...detaildoc.data(), id: detaildoc.id });
        //console.log(detaildoc.data());
      });
      options.push({ option: doc.data().option, detail, id: doc.id });
      // //console.log(doc.id, '=>', doc.data());
      // //console.log(options);
    });

    //console.log(options);

    const variations = [];
    let variationquery = firestore
      .collection('restaurant')
      .doc(restid)
      .collection('categories')
      .doc(catid)
      .collection('items')
      .doc(itemid)
      .collection('variations')
      .get();
    (await variationquery).forEach(vdoc => {
      variations.push({ ...vdoc.data(), id: vdoc.id });
    });

    //console.log(variations);
    dispatch({
      type: 'getItemByID',
      payload: { itemid, catid, options, variations }
    });
    dispatch({ type: 'clearError' });
    // //console.log("end")
  } catch (err) {
    //console.log(err);
    dispatch({
      type: 'setError',
      payload: {
        msg: err.message,
        status: 'error',
        id: err.code
      }
    });
  }
  // } else {
  //   //console.log('error');
  // }
  // });
};

// Update new restaurant
export const updateItem = item => async (dispatch, getState) => {
  //console.log('inside update items');
  //restaurant.userId = user.uid
  delete item.options;
  delete item.variations;

  var user = firebase.auth().currentUser;
  if (user) {
    //console.log(user);

    const state = getState();
    //console.log(state);
    delete item.options;
    delete item.variations;
    const preitem = state.restaurantState.categories.find(
      cat => cat.id === item.id
    );

    firestore
      .collection('restaurant')
      .doc(state.restaurantState.attributes.id)
      .collection('categories')
      .doc(item.catid)
      .collection('items')
      .doc(item.id)
      .set({ ...preitem, ...item })
      .then(res => {
        //console.log(res);
        dispatch({ type: 'UpdateItem', payload: { ...preitem, ...item } });
        dispatch({ type: 'clearError' });
      })
      .catch(err => {
        //console.log(err);
        dispatch({
          type: 'setError',
          payload: {
            msg: err.message,
            status: 'error',
            id: err.code
          }
        });
      });
  } // user is undefined if no user signed in
  else
    dispatch({
      type: 'setError',
      payload: {
        msg: '',
        status: 'error',
        id: 77889
      }
    });
};

//updateSpecific
//
export const updateSpecific = (path, values, addopt = false) => async (
  dispatch,
  getState
) => {
  //console.log('inside update items');
  //restaurant.userId = user.uid
  var user = firebase.auth().currentUser;
  if (user) {
    //console.log(user);

    const state = getState();
    //console.log(state);
    //console.log(values);

    //console.log(path);

    if (addopt)
      firestore
        .collection('restaurant')
        .doc(state.restaurantState.attributes.id)
        .collection('categories' + path)
        .add({ ...values })
        .then(res => {
          //console.log(res);
          dispatch({ type: 'UpdateSpecific', payload: { values } });
          dispatch({ type: 'clearError' });
        })
        .catch(err => {
          //console.log(err);
          dispatch({
            type: 'setError',
            payload: {
              msg: err.message,
              status: 'error',
              id: err.code
            }
          });
        });
    else
      firestore
        .collection('restaurant')
        .doc(state.restaurantState.attributes.id)
        .collection('categories')
        .doc(path)
        .set({ ...values })
        .then(res => {
          //console.log(res);
          dispatch({ type: 'UpdateSpecific', payload: { values } });
          dispatch({ type: 'clearError' });
        })
        .catch(err => {
          //console.log(err);
          dispatch({
            type: 'setError',
            payload: {
              msg: err.message,
              status: 'error',
              id: err.code
            }
          });
        });
  } // user is undefined if no user signed in
  else
    dispatch({
      type: 'setError',
      payload: {
        msg: '',
        status: 'error',
        id: 77889
      }
    });
};

export const deleteSpecific = path => async (dispatch, getState) => {
  //console.log( '>>>>>>>>>>>>>>>>inside del items');
  //restaurant.userId = user.uid
  var user = firebase.auth().currentUser;
  if (user) {
    // //console.log(user);

    const state = getState();
    //console.log(state);
    //console.log(path);
    // subs.map.()

    firestore
      .collection('restaurant')
      .doc(state.restaurantState.attributes.id)
      .collection('categories')
      .doc(path)
      .delete()
      .then(res => {
        //console.log(res);
        dispatch({ type: 'deleteSpecific', payload: { path } });
        dispatch({ type: 'clearError' });
      })
      .catch(err => {
        //console.log(err);
        dispatch({
          type: 'setError',
          payload: {
            msg: err.message,
            status: 'error',
            id: err.code
          }
        });
      });
    // else
    //   firestore
    //     .collection('restaurant')
    //     .doc(state.restaurantState.attributes.id)
    //     .collection('categories')
    //     .doc(path)
    //     .set({ ...values })
    //     .then(res => {
    //       //console.log(res);
    //       dispatch({ type: 'UpdateSpecific', payload: { values } });
    //       dispatch({ type: 'clearError' });
    //     })
    //     .catch(err => {
    //       //console.log(err);
    //       dispatch({
    //         type: 'setError',
    //         payload: {
    //           msg: err.message,
    //           status: 'error',
    //           id: err.code
    //         }
    //       });
    //     });
  } // user is undefined if no user signed in
  else
    dispatch({
      type: 'setError',
      payload: {
        msg: '',
        status: 'error',
        id: 77889
      }
    });
};

export const listGenericOpt = catid => async (dispatch, getState) => {
  //console.log('inside addGenericOpt items');
  //restaurant.userId = user.uid
  var user = firebase.auth().currentUser;
  if (user) {
    //console.log(user);

    const state = getState();
    //console.log(state);

    let catRef = firestore
      .collection('restaurant')
      .doc(state.restaurantState.attributes.id)
      .collection('categories')
      .doc(catid)
      .collection('genericOptions');

    try {
      // const arestaurants = await restaurantRef.get();
      const genarray = await catRef.get();
      const genOpts = [];

      //console.log(genarray);
      genarray.forEach(async genopt => {
        //console.log(genopt.id);
        let detail = [];
        // //console.log('inside try block');
        // const dref = firestore
        //   .collection('restaurant')
        //   .doc(state.restaurantState.attributes.id)
        //   .collection('categories')
        //   .doc(catid)
        //   .collection('genericOptions')
        //   .doc(genopt.id)
        //   .collection('detail');
        // //console.log('create ref');
        // let detailquery = await dref.get();
        // //console.log(detailquery);

        // detailquery.forEach(detaildoc => {
        //   //console.log(detaildoc.data());

        //   detail.push({ ...detaildoc.data(), id: detaildoc.id });

        //   //console.log(detaildoc.data());
        // });

        // //console.log(detail)

        genOpts.push({ ...genopt.data(), id: genopt.id });
      }); //foreach closed

      //console.log(genOpts);

      dispatch({ type: 'listGenericOptions', payload: { genOpts, catid } });
      dispatch({ type: 'clearError' });
      // //console.log("end")
    } catch (err) {
      //console.log(err);
      dispatch({
        type: 'setError',
        payload: {
          msg: err.message,
          status: 'error',
          id: err.code
        }
      });
    }
  } // user is undefined if no user signed in
  else
    dispatch({
      type: 'setError',
      payload: {
        msg: '',
        status: 'error',
        id: 77889
      }
    });
};

// get all available restaurants
export const getRestaurantById = restid => async (dispatch, getState) => {
  // //console.log("****************************************************************************")
  // //console.log(catid,itemid)
  // const state = getState();
  // //console.log(state.authState);
  var user = firebase.auth().currentUser;
  //console.log(user);
  //if (user) {
  //console.log('***********************************inside*****************************************');
  //console.log(restid);
  const state = getState();
  //console.log(state);

  let restaurantquery = firestore.collection('restaurant').doc(restid);
  try {
    // const arestaurants = await restaurantRef.get();
    const restaurant = await restaurantquery.get();

    // console.log(restaurant);

    let categories = [];
    // console.log(restaurant.data());

    const attributes = restaurant.data();
    attributes.id = restaurant.id;

    let categoryquery = await restaurantquery
      .collection('categories')
      .orderBy('sno')
      .get();
    categoryquery.forEach(catdoc => {
      categories.push({ ...catdoc.data(), id: catdoc.id });
      restaurantquery
        .collection('categories')
        .doc(catdoc.id)
        .collection('items')
        .get()
        .then(snapshot => {
          //console.log(snapshot);

          const items = [];
          snapshot.forEach(doc => {
            const variations = [];
            restaurantquery
              .collection('categories')
              .doc(catdoc.id)
              .collection('items')
              .doc(doc.id)
              .collection('variations')
              .orderBy('price', 'desc')
              .get()
              .then(snapshot => {
                snapshot.forEach(vdoc =>
                  variations.push({ id: vdoc.id, ...vdoc.data() })
                );
                //console.log(variations);
                items.push({ id: doc.id, ...doc.data(), variations });
                dispatch({
                  type: 'listItems',
                  payload: { catid: catdoc.id, items }
                });
              });
            //items.push({ id: doc.id, ...doc.data(), variations });
          });
          // dispatch({
          //   type: 'listItems',
          //   payload: { catid: catdoc.id, items }
          // });
        });

      restaurantquery
        .collection('categories')
        .doc(catdoc.id)
        .collection('genericOptions')
        .get()
        .then(snapshot => {
          //console.log(snapshot);

          const genOpts = [];
          snapshot.forEach(doc => {
            genOpts.push({ id: doc.id, ...doc.data() });
          });
          dispatch({
            type: 'listGenericOptions',
            payload: { catid: catdoc.id, genOpts }
          });
        })
        .catch(err => {
          //console.log(err);
          dispatch({
            type: 'setError',
            payload: {
              msg: err.message,
              status: 'error',
              id: err.code
            }
          });
        });
        

      //console.log(catdoc.data());
    });

    dispatch({
      type: 'setRestaurant',
      payload: { attributes, categories }
    });
    dispatch({ type: 'clearError' });
    // //console.log("end")
  } catch (err) {
    //console.log(err);
    dispatch({
      type: 'setError',
      payload: {
        msg: err.message,
        status: 'error',
        id: err.code
      }
    });
  }
  // } else {
  //   //console.log('error');
  // }
  // });
};

//getItemGenericOptions

// export const getItemGenericOptions = (cid, tid, rid) => async (
//   dispatch,
//   getState
// ) => {
//   //console.log("getting generic options ---------->");
//   const state = getState();
//   //console.log(state);

//   try {
//     let itemquery = firestore
//       .collection('restaurant')
//       .doc(rid)
//       .collection('categories')
//       .doc(cid)
//       .collection("items")
//       .doc(tid);

//     // const arestaurants = await restaurantRef.get();
//     const item = await itemquery.get();

//     //console.log(item);

//     //console.log(item.data());

//     const itemGenericOption = item.data();

//     const goptionquery = await firebase
//       .collection('restaurant')
//       .doc(rid)
//       .collection('categories')
//       .doc(cid)
//       .collection('genericOptions')
//       .where('id','array-contains',itemGenericOption);
//       .get();

//       goptionquery.forEach(catdoc => {
//       categories.push({ ...catdoc.data(), id: catdoc.id });
//       restaurantquery
//         .collection('categories')
//         .doc(catdoc.id)
//         .collection('items')
//         .get()
//         .then(snapshot => {
//           //console.log(snapshot);

//           const items = [];
//           snapshot.forEach(doc => {
//             items.push({ id: doc.id, ...doc.data() });
//           });
//           dispatch({
//             type: 'listItems',
//             payload: { catid: catdoc.id, items }
//           });
//         });

//       //console.log(catdoc.data());
//     });

//     dispatch({
//       type: 'setRestaurant',
//       payload: { attributes, categories }
//     });
//     dispatch({ type: 'clearError' });
//     // //console.log("end")
//   } catch (err) {
//     //console.log(err);
//     dispatch({
//       type: 'setError',
//       payload: {
//         msg: err.message,
//         status: 'error',
//         id: err.code
//       }
//     });
//   }
//   // });
// };
